/**
 * @file Maintenance technician text-option control adapter.
 */

import {
  createTextOptionControl,
} from "../../shared/ui/controls/textOptionControl.js";

function normalizeTechnicianOptions(appData = {}, selectedValue = "") {
  const selected = String(selectedValue || "").trim();
  const options = (appData?.config?.maintenance?.technicians || [])
    .map((entry) => ({
      value: String(entry?.name || "").trim(),
      label: String(entry?.name || "").trim(),
      order: Number(entry?.order ?? 9999),
      isActive: entry?.isActive !== false,
    }))
    .filter((entry) => entry.value)
    .filter((entry) => entry.isActive || entry.value === selected)
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label));

  if (selected && !options.some((entry) => entry.value === selected)) {
    options.push({
      value: selected,
      label: selected,
      order: 10000,
      isActive: true,
    });
  }
  return options;
}

/**
 * Renders the mount root for a Maintenance technician control.
 * @returns {string} Root HTML.
 */
export function renderMaintenanceTechnicianControlRoot() {
  return '<div data-maintenance-technician-control></div>';
}

/**
 * Mounts the Maintenance technician selector.
 * @param {object} params Mount params.
 * @param {HTMLElement} params.root Mount root.
 * @param {object} params.appData App data/config.
 * @param {string} [params.value] Current technician value.
 * @param {boolean} [params.required=false] Whether the value is required.
 * @param {boolean} [params.disabled=false] Whether the control is disabled.
 * @param {Function} [params.onChange] Change callback.
 * @returns {object|null} Registered control handle.
 */
export function mountMaintenanceTechnicianControl({
  root,
  appData = {},
  value = "",
  required = false,
  disabled = false,
  onChange,
} = {}) {
  if (!root) {return null;}
  return createTextOptionControl({
    root,
    name: "technician",
    value,
    options: normalizeTechnicianOptions(appData, value),
    placeholder: "Select or enter technician",
    accessibleName: "Technician",
    required,
    disabled,
    onChange,
  });
}
